import { render } from "./legendary-action.vue?vue&type=template&id=1d1aed11"
import script from "./legendary-action.vue?vue&type=script&lang=js"
export * from "./legendary-action.vue?vue&type=script&lang=js"

import "./legendary-action.vue?vue&type=style&index=0&id=1d1aed11&lang=scss"

import exportComponent from "D:\\repos\\rivendom-compendium\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__